import { useNavigate } from 'react-router-dom';
import webPostRaw from './webPostRaw';

const useWebPost = () => {
  const navigate = useNavigate();

  const webPost = async (endpoint, data) => {
    return await webPostRaw(endpoint, data, navigate);
  };

  return webPost;
};

export default useWebPost;